import script from "./OrderAnalyticsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderAnalyticsBlock.vue?vue&type=script&setup=true&lang=js"

import "./OrderAnalyticsBlock.vue?vue&type=style&index=0&id=4e0636ba&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e0636ba"]])

export default __exports__